import { Checkbox, CheckboxField } from './fragments/Checkbox';
import { Label } from './fragments/FieldSet';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  name: string;
}

export const CheckboxComponent: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  disabled,
  label,
  required,
  name
}) => {
  return (
    <div className='flex items-start gap-2'>
      <Checkbox
        className='flex-none mt-0.5'
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <Label required={required}>{label}</Label>
    </div>
  );
};
